import {
  Card,
  CardContent,
  ClickAwayListener,
  Grow,
  IconButton,
  Popper,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';
import { PartialMUIPopperProps } from '../types';
import { useStyles } from './styles';

interface AdviceCardProps extends PartialMUIPopperProps {
  content: ReactNode;
  hasClickAwayListener: boolean | undefined;
  hasCross: boolean | undefined;
  onCloseClick: () => void;
  tipPosition: number | undefined;
  zIndex: number | undefined;
}

export const AdviceCard: FC<AdviceCardProps> = ({
  content,
  hasClickAwayListener,
  hasCross = true,
  onCloseClick,
  tipPosition,
  zIndex,
  ...PopperProps
}) => {
  const classes = useStyles({ tipPosition, zIndex });

  return (
    <Popper className={classes.popper} transition {...PopperProps}>
      {({ TransitionProps, placement }) => (
        <ClickAwayListener
          {...(hasClickAwayListener && { mouseEvent: 'onMouseDown' })}
          onClickAway={(e) => {
            if (!(PopperProps?.anchorEl as any).contains(e.target)) {
              onCloseClick();
            }
          }}
        >
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Card
              className={clsx(
                classes.card,
                placement.includes('top') && classes.cardTop,
                placement.includes('right') && classes.cardRight,
                placement.includes('bottom') && classes.cardBottom,
                placement.includes('left') && classes.cardLeft,
              )}
              raised
            >
              <CardContent className={classes.cardContent}>
                {hasCross && (
                  <IconButton
                    className={classes.closeButton}
                    color="primary"
                    onClick={() => {
                      onCloseClick();
                    }}
                    size="small"
                  >
                    <Close fontSize="small" />
                  </IconButton>
                )}

                {content}
              </CardContent>
            </Card>
          </Grow>
        </ClickAwayListener>
      )}
    </Popper>
  );
};
